// Per-tab identifier — one browser tab = one id, stable across reloads within
// the tab. sessionStorage is per-tab and cleared when the tab closes, which is
// exactly the lifetime the ops-dashboard "open tabs per user" metric wants.
// Sent as the X-Tab-Id header on API requests and the ?tab= param on sockets.
export const getTabId = () => {
  try {
    let id = sessionStorage.getItem("tabId");
    if (!id) {
      id =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : `t-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem("tabId", id);
    }
    return id;
  } catch {
    // Private mode / storage disabled — degrade quietly; the backend just
    // treats a missing tab id as "no tab signal" for this request.
    return "";
  }
};
